export default {
  name: 'marking--outDocType',
};